import { useMutation, useQueryCache } from "react-query";
import { putNotifySubscriptionPreference } from "../../../queries/notify";
import { useAnonymousOrNormalNetworkHeaders } from "../../auth/hooks/useAnonymousOrNormalNetworkHeaders";
import { buildNotifySubscriberContactMethodsQueryKey } from "./useNotifySubscriberContactMethodsForLoggedInUser";
import { buildNotifySubscriberContactMethodQueryKey } from "./useNotifySubscriberContactMethod";

interface IUseNotifySubscriptionPreferenceUpdate {
  onSuccess?: (res: {
    subscriberContactMethodId: number;
    subscriptionGroupId: number;
    subscriptionGroup: { name: string };
    type: string;
  }) => void;
  onError?: (error: unknown) => void;
}

export function useNotifySubscriptionPreferenceUpdate({ onSuccess }: IUseNotifySubscriptionPreferenceUpdate = {}) {
  const networkHeaders = useAnonymousOrNormalNetworkHeaders();
  const queryCache = useQueryCache();

  const [editSubscriptionPreferenceMutation, { isLoading: isEditSubscriptionPreferenceLoading }] = useMutation(
    putNotifySubscriptionPreference(networkHeaders),
    {
      onSuccess: async (data) => {
        await queryCache.invalidateQueries(
          buildNotifySubscriberContactMethodQueryKey({ id: data.subscriberContactMethodId }),
        );
        await queryCache.invalidateQueries(buildNotifySubscriberContactMethodsQueryKey());

        if (onSuccess) {
          onSuccess(data);
        }
      },
    },
  );

  const editSubscriptionPreference = async ({
    subscriberContactMethodId,
    subscriptionGroupId,
    type,
  }: {
    subscriberContactMethodId: number;
    subscriptionGroupId: number;
    type: "Subscribe" | "Unsubscribe";
  }) => {
    return await editSubscriptionPreferenceMutation({
      id: subscriberContactMethodId,
      body: {
        subscriptionGroupId,
        type,
      },
    });
  };

  return { editSubscriptionPreference, isEditSubscriptionPreferenceLoading };
}
